<ion-col size="12" size-md="3"
  class="d-flex ion-justify-content-end"
  style="margin-left: auto;"
>

  <span 
    class="ml-5 mt-10 fs-20 material-icons btn-reset"
    style="cursor:pointer;"
    [class.clicked]="isClicked"
    (click)="resetGrid(); isClicked = true"
    (animationend)="isClicked = false">
    refresh
  </span>

</ion-col>


<div class="resign-asset-grid">
<ag-grid-angular
  style="width: 100%; height: 400px;"
  class="ag-theme-alpine"
  [rowData]="listofFromData"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  [rowSelection]="rowSelection"
  [animateRows]="true"
  (cellClicked)="onCellClicked($event)"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>

</div>
